//#region src/integrations/deepseek/deepseekTypes.ts
const DEEPSEEK_INTEGRATION_ID = "deepseek";
const DEEPSEEK_DEFAULT_BASE_URL = "https://api.deepseek.com/v1";
const DEEPSEEK_LOGO_URL = "/logos/deepseek/logo.svg";

//#endregion
export { DEEPSEEK_DEFAULT_BASE_URL, DEEPSEEK_INTEGRATION_ID, DEEPSEEK_LOGO_URL };
//# sourceMappingURL=deepseekTypes.js.map